import React from "react";

function TextHeader(props) {
  return (
    <h5 className="text-dark fw-bold mb-4">{props.text}</h5>
  );
}

export default TextHeader;